import { useCallback, useState } from 'react';
import { App } from 'antd';
import { guardedClient } from '../../auth/api/clients';
import { formatErrorMessage } from '../utils/formatErrorMessage';

export const useCallRequest = () => {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);

  const submit = useCallback(
    async (rpmApplicantId: string): Promise<{ success: boolean; errorMessage?: string }> => {
      setLoading(true);
      try {
        await guardedClient.applications.$post({
          json: { rpmApplicantId },
        });
        message.success('架電依頼に成功しました');
        return { success: true };
      } catch (error) {
        console.error('架電依頼エラー:', error);

        if (error && typeof error === 'object' && 'name' in error && error.name === 'HttpError' && 'body' in error) {
          const body = error.body;
          if (body && typeof body === 'object') {
            const errorMessage = formatErrorMessage(body as Record<string, unknown>);
            return { success: false, errorMessage };
          }
        }

        return { success: false, errorMessage: '架電依頼に失敗しました。しばらく待ってから再度お試しください。' };
      } finally {
        setLoading(false);
      }
    },
    [message]
  );

  return { submit, loading };
};
